import store from "redux/store"
import { savetk, sessionTimeOut, totalTimeSession, descTK } from "./services";
import { getExp, updateSessionAction, getIat, signOffUserAction } from "redux/actions/userActions";

const UseSecurity = () => {

    const dispatch = store.dispatch;

    const isSingIn = () => {
        const user = store.getState().user;

        if (user.tk && typeof user.tk === 'string') {
            const exp = getExp(user.tk);     
            const now = Date.now() / 1000;   

            return exp > now;             
        }

        return false;
    }

    function getSessionTimeOut() {
        const user = store.getState().user;
        return user.tk ? sessionTimeOut(getExp(user.tk)) : 0;
    }

    async function getTk() {
        const user = store.getState().user;
        const exp = getExp(user.tk);       
        const now = Date.now() / 1000;    

        if ((exp - now) < 120) {            
            await updateTk();               
        }

        const fresh = store.getState().user; 
        const tok = descTK(fresh.tk, fresh.ruc);
        return fresh.type + " " + tok;
    }

    function updateTk() {
        return new Promise((resolve, reject) => {
            dispatch(updateSessionAction(resolve, reject));
        });
    }

    function getTotalTimeSession() {
        const user = store.getState().user;
        return user.tk ? totalTimeSession(getExp(user.tk), getIat(user.tk)) : 0;
    }

    function signout() {
        dispatch(signOffUserAction());
    }

    return {
        isSingIn,
        savetk,
        sessionTimeOut: getSessionTimeOut,
        getTk,
        updateTk,
        getTotalTimeSession,
        signout,
        descTK
    };
}

export default UseSecurity;